import React, { useState } from 'react';
import './SelfCheckout.css';

const SelfCheckout = () => {
  const [activeTab, setActiveTab] = useState('Home'); // Default active tab

  const tabContent = {
    Home: {
      description:
        'Manage your retail operations with just a laptop and our advanced system. Say goodbye to bulky point-of-sale terminals and embrace efficiency with minimal hardware.',
      imageSrc: '/image/checkout.png',
    },
    'Mobile Application': {
      description:
        'Empower your customers with self-checkout capabilities. Using our mobile app, they can easily scan product barcodes and complete their purchase seamlessly.',
      imageSrc: '/image/mobile_app.png',
    },
    'Indoor Mapping': {
      description:
        'Help your customers navigate effortlessly with our indoor mapping feature, allowing them to seamlessly locate products in your retail store.',
      imageSrc: '/image/indoor_map.png',
    },
    Documentation: {
      description:
        'Seamlessly integrate our self-checkout system with your existing point-of-sale setup using our comprehensive and easy-to-follow documentation.',
      imageSrc: '/image/documentation.png',
    },
    Security: {
      description:
        'Our system is designed with security at its core, ensuring robust measures to prevent pilferage and safeguard your retail store operations.',
      imageSrc: '/image/security.png',
    },
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="self-checkout-card">
      {/* The parent container holds text + image. 
          The new CSS media queries will stack them vertically on small screens. */}
      <div className="self-checkout-card-section">
        
        {/* Left (text) column */}
        <div className="self-checkout-text-content">
          <h2 className="self-checkout-section-title">Self Check-Out System</h2>
          <p className="self-checkout-section-subtitle">
            Automate your retail store using our system and save on operational cost.
          </p>

          {/* Tabs become a scrollable row on small screens due to CSS overflow-x */}
          <div className="self-checkout-tags">
            {Object.keys(tabContent).map((tab) => (
              <span
                key={tab}
                className={`self-checkout-tag ${activeTab === tab ? 'active' : ''}`}
                onClick={() => handleTabClick(tab)}
              >
                {tab}
              </span>
            ))}
          </div>

          <p className="self-checkout-section-description">
            {tabContent[activeTab]?.description || 'Default description'}
          </p>

          <button className="self-checkout-action-button">
            Contact Us &rarr;
          </button>
        </div>
        
        {/* Right (image) column */}
        <div className="self-checkout-image-content">
          {tabContent[activeTab].imageSrc && (
            <img
              src={tabContent[activeTab].imageSrc}
              alt={`${activeTab} Example`}
              className="self-checkout-image"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default SelfCheckout;
